<!-- <div class="d-flex label-container">
  <div class="d-flex info-container" (click)="toggle()">
    <ion-label text-wrap id="name" [ngClass]="{ bold: this.boldLabelStyle }">{{ title }}</ion-label>
  </div>
  <ion-toggle [(ngModel)]="checked" (ngModelChange)="checkedChanged.emit($event)"></ion-toggle>
</div> -->

<doka-toggle
  [label]="title"
  [desc]="description"
  [checked]="checked"
  (checkedChange)="checkedChanged.emit()"
  [rightAlign]="true"></doka-toggle>
